var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPb1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 16,
    fill: "url(#paint0_linear_1983_1153)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9624 28.604C14.9624 28.82 14.8004 29 14.5844 29H12.9284C12.7124 29 12.5504 28.82 12.5504 28.604V16.778C12.5504 16.58 12.7124 16.4 12.9284 16.4H17.6624C20.6324 16.4 22.1624 18.308 22.1624 20.558C22.1624 22.808 20.6324 24.716 17.6624 24.716H14.9624V28.604ZM14.9624 22.592H17.5004C18.7064 22.592 19.6604 21.818 19.6604 20.558C19.6604 19.298 18.7064 18.524 17.5004 18.524H14.9624V22.592ZM29.4575 16.4C32.4455 16.4 33.5075 18.146 33.5075 19.586C33.5075 20.72 32.9315 21.728 31.8155 22.196C33.4715 22.754 34.1555 24.032 34.1555 25.328C34.1555 27.2 32.6975 29 29.9435 29H23.9675C23.7515 29 23.5895 28.838 23.5895 28.622V16.778C23.5895 16.58 23.7335 16.4 23.9675 16.4H29.4575ZM31.0235 19.91C31.0235 18.974 30.3575 18.308 29.1335 18.308H26.0015V21.53H29.1335C30.3575 21.53 31.0235 20.864 31.0235 19.91ZM29.5655 23.348H26.0015V27.092H29.5655C30.7175 27.092 31.6535 26.372 31.6535 25.22C31.6535 24.086 30.7355 23.348 29.5655 23.348Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1983_1153",
    x1: -5.5,
    y1: -1.5,
    x2: 66,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3253DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75DAB4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPb1);
export default __webpack_public_path__ + "static/media/pb1.0c846a01b5ed467d812b0fee118a3d34.svg";
export { ForwardRef as ReactComponent };